import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
  signal,
} from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";
import { KsgPopover, KsgAvatar, KsgIcon } from "@ksg/ui";
import {
  HrCompaniesService,
  AssignedCompany,
} from "../../../core/company/hr-companies.service";
import { AuthService } from "../../../core/auth/auth.service";

@Component({
  selector: "app-company-switcher",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe, KsgPopover, KsgAvatar, KsgIcon],
  templateUrl: "./company-switcher.html",
})
export class CompanySwitcher implements OnInit {
  readonly companiesService = inject(HrCompaniesService);
  private readonly authService = inject(AuthService);

  readonly collapsed = input(false, { transform: booleanAttribute });

  protected readonly open = signal(false);

  ngOnInit(): void {
    if (this.authService.isAuthenticated() && !this.companiesService.loaded()) {
      this.companiesService.loadCompanies().subscribe({ error: () => {} });
    }
  }

  select(company: AssignedCompany): void {
    this.companiesService.selectCompany(company.id);
    this.open.set(false);
  }

  logout(): void {
    this.authService.logout();
  }

  companyInitials(name: string): string {
    return name
      .split(" ")
      .slice(0, 2)
      .map((w) => w[0] ?? "")
      .join("")
      .toUpperCase();
  }
}
